<template>
    <div class="FormToggle" :class="{ checked: value }">
        <input ref="input" :id="`I${_uid}`" v-bind="$attrs" type="checkbox" :checked="value" @input="$emit('input', $event.target.checked)"/>
        <label :for="`I${_uid}`" @click.prevent="$refs.input.click()"></label>
    </div>
</template>

<script>
export default {
    name: 'FormToggle',

    props: {
        value: { type: Boolean },
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';
$toggle-size: 30px;
$toggle-border-size: 2px;

.FormToggle {
    label {
        display: block;
        width: $toggle-size * 2;
        height: $toggle-size;
        border: $toggle-border-size solid $bg-color-4;
        border-radius: $toggle-size;
        margin: 0;
        background-color: $bg-color-4;
        position: relative;
        cursor: pointer;

        &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            display: block;
            width: calc(#{$toggle-size} - #{$toggle-border-size} * 2);
            height: calc(#{$toggle-size} - #{$toggle-border-size} * 2);
            background-color: #fff;
            border-radius: 50%;
            user-select: none;
            transition: transform 175ms cubic-bezier(.22,.61,.36,1);
            will-change: transform;
        }
    }

    input {
        display: none;
    }


    &.checked label {
        background-color: $green-color;
        border-color: $green-color;

        &:before {
            transform: translateX(calc(100% + #{$toggle-border-size * 2}));
        }
    }
}
</style>
